export const orderByValues = {
  sales: 'sales',
  returns: 'returns',
  ratio: 'ratio',
  refunds: 'refunds',
  amount: 'amount',
  count: 'count',
  refundCount: 'refund_count',
  exchangeCount: 'exchange_count',
}
